import React from "react";
import Product from "./Product";

const LandingPage = () => {
  return (
    <div className="top-16  bg-[rgb(241,243,246)]  h-fit w-[100vw]  absolute">
      <Product />
    </div>
  );
};

export default LandingPage;
